import defaults from 'lodash/defaults';
import pickBy from 'lodash/pickBy';
import api from './api';

/**
 * @typedef TemplateInput
 * @property {string} name
 * @property {string[] | null} primary_targets
 * @property {string[] | null} secondary_targets
 */

/**
 * @param {TemplateInput} template
 * @returns {Promise<{
 *  target_template_id: string
 *  name: string
 *  primary_targets: string[] | null
 *  secondary_targets: string[] | null
 * }>}
 */
export default async function createAutomarkerTargetTemplate(template) {

    template = defaults(
        pickBy(template, value => value?.length > 0),
        {
            name: '',
            primary_targets: null,
            secondary_targets: null,
        }
    );

    const { data } = await api.post('target_templates', template);

    return data;
}